import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";

@Component({
    selector: "wbo-dietary-indicator-multi-select-column",
    templateUrl: "./dietary-indicator-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => DietaryIndicatorMultiSelectColumnComponent), multi: true}
    ]
})
export class DietaryIndicatorMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {
    constructor(injector: Injector) {
        super(injector, "id", "code");
    }
}
